export default __webpack_public_path__ + "media/zurb/img/playground/thumbtack-4161b06ee185e94eff586f8ffd5c3a36.png";